var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33302 8.02083C2.15261 8.02083 1.99069 8.13158 1.92529 8.29972C1.85988 8.46787 1.9044 8.65892 2.0374 8.78083L5.5374 11.9892C5.66529 12.1064 5.85038 12.137 6.00919 12.0671C6.168 11.9973 6.27053 11.8402 6.27053 11.6667L6.27053 2.33333C6.27053 2.0917 6.07465 1.89583 5.83303 1.89583C5.5914 1.89583 5.39553 2.0917 5.39553 2.33333L5.39553 8.02083L2.33302 8.02083Z",
    fill: "#0D1615"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6664 5.97916L8.60386 5.97916L8.60386 11.6667C8.60386 11.9083 8.40798 12.1042 8.16636 12.1042C7.92474 12.1042 7.72886 11.9083 7.72886 11.6667L7.72886 2.33333C7.72886 2.15983 7.83138 2.00272 7.99019 1.93286C8.149 1.863 8.33409 1.89358 8.46199 2.01082L11.962 5.21915C12.095 5.34107 12.1395 5.53212 12.0741 5.70026C12.0087 5.86841 11.8468 5.97916 11.6664 5.97916Z",
    fill: "#0D1615"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferSwitch);
export default __webpack_public_path__ + "static/media/transfer-switch.984ef820722ea683670658af969db733.svg";
export { ForwardRef as ReactComponent };